const toRelationsArray = (relationsOrRelation) => {
  if (Array.isArray(relationsOrRelation)) return relationsOrRelation
  if (!relationsOrRelation) return []

  return [relationsOrRelation]
}

export const getStoreRelationBrandEntries = (relation) => {
  if (Array.isArray(relation?.brands) && relation.brands.length > 0) {
    return relation.brands.filter(Boolean)
  }

  if (relation?.brand || relation?.status) {
    return [relation]
  }

  return []
}

export const getStoreRelationStatusEntries = (relationsOrRelation) => {
  return toRelationsArray(relationsOrRelation).flatMap((relation) => getStoreRelationBrandEntries(relation))
}

export const resolveStoreRelationAssignmentStatus = (relationsOrRelation) => {
  const statusEntries = getStoreRelationStatusEntries(relationsOrRelation).filter(Boolean)
  const hasAnyError = statusEntries.some((item) => item?.status === 'error')
  const hasAnySuspended = statusEntries.some((item) => item?.status === 'suspended')
  const allBrandsInError = statusEntries.length > 0 && statusEntries.every((item) => item?.status === 'error')
  const requiresReassignment = statusEntries.length > 0 && statusEntries.every(
    (item) => item?.status === 'error' && item?.active === false
  )

  return {
    hasAnyError,
    hasAnySuspended,
    allBrandsInError,
    requiresReassignment
  }
}

export const requiresStoreRelationPrincipalReassignment = (storeRelation) => {
  const principalRelation = storeRelation?.client_principal || null
  const principalSalesman = principalRelation?.salesman || null

  return Boolean(
    principalRelation && (
      principalRelation?.status === 'error' ||
      principalRelation?.active === false ||
      principalSalesman?.active === false
    )
  )
}

export const isSameStoreRelationSalesman = (leftSalesman, rightSalesman) => {
  if (!leftSalesman || !rightSalesman) return false

  return (
    (leftSalesman?.id && rightSalesman?.id && leftSalesman.id === rightSalesman.id) ||
    (leftSalesman?.db_ref && rightSalesman?.db_ref && leftSalesman.db_ref === rightSalesman.db_ref)
  )
}
